module.exports = __webpack_public_path__ + "assets/5bd40fa8a7c20736035c716bc2ac353f.png";